import Decimal from 'decimal.js';

// Onchain sqrt prices can exceed IEEE-754 precision. Round only for presentation.
export const Money = Decimal.clone({
  precision: 100,
  rounding: Decimal.ROUND_HALF_EVEN,
});
export function positiveDecimal(value: unknown): string | null {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  try {
    const number = new Money(value);
    return number.isFinite() && number.gt(0) ? number.toFixed() : null;
  } catch {
    return null;
  }
}
export function usdValue(pairPrice: string, quoteUsd: string): string {
  return new Money(pairPrice).mul(quoteUsd).toFixed();
}
export function usdMarketCap(
  supply: string,
  decimals: number,
  priceUsd: string,
): string {
  return new Money(supply)
    .div(new Money(10).pow(decimals))
    .mul(priceUsd)
    .toFixed();
}
export function priceFromSqrtExact(
  sqrt: bigint,
  tokenIs0: boolean,
  decimals: number,
  quoteDecimals: number,
): string | null {
  if (sqrt <= 0n) return null;
  const ratio = new Money(sqrt.toString()).div(new Money(2).pow(96)).pow(2);
  return (tokenIs0 ? ratio : new Money(1).div(ratio))
    .mul(new Money(10).pow(decimals - quoteDecimals))
    .toFixed();
}
export function retainsHalfUsd(p0: string, pt: string): boolean | null {
  try {
    const start = new Money(p0),
      end = new Money(pt);
    if (!start.isFinite() || !end.isFinite() || start.lte(0) || end.lt(0))
      return null;
    return end.mul(2).gte(start);
  } catch {
    return null;
  }
}
